import React, { useState } from "react";
import "./ConfirmOrderPage.scss";
import InputField from "../../Components/InputField/InputField";
import Button from "../../Components/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { API_URL } from "../../Config/constant";
import { setCart } from "../../Redux/Cart/Cart.actions";

const ConfirmOrderPage = ({ history }) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNo, setPhoneNo] = useState();
  const [city, setCity] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [address, setAddess] = useState();
  const [showLoading, setShowLoading] = useState(false);
  const cart = useSelector((state) => state.cart.cart);
  const dispatch = useDispatch();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowLoading(true);
    const body = {
      firstName,
      lastName,
      email,
      phoneNo,
      city,
      postalCode,
      address,
      products: cart,
    };
    const res = await axios.post(`${API_URL}/orders/place-order`, body);

    if (res.data.success) {
      setShowLoading(false);
      dispatch(setCart([]));
      history.push("/thank-you");
      return;
    }
    alert("something went wrong.");
    setShowLoading(false);
  };

  return (
    <div className="ConfirmOrderPage">
      <h1>Confirm Order</h1>
      <p>Please fill Out The Details Below to Confirm Your Order</p>

      <div className="co-content">
        <form onSubmit={(e) => handleSubmit(e)}>
          <InputField
            required
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            width="90%"
            placeholder="First Name"
            black
            type="text"
          />
          <InputField
            required
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            width="90%"
            placeholder="Last Name"
            black
            type="text"
          />
          <InputField
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            width="90%"
            placeholder="Email"
            black
            type="email"
          />
          <InputField
            required
            value={phoneNo}
            onChange={(e) => setPhoneNo(e.target.value)}
            width="70%"
            placeholder="Phone No"
            type="number"
            black
          />
          <InputField
            required
            value={city}
            onChange={(e) => setCity(e.target.value)}
            width="40%"
            placeholder="City"
            black
            type="text"
          />
          <InputField
            required
            value={postalCode}
            onChange={(e) => setPostalCode(e.target.value)}
            width="40%"
            placeholder="Postal Code"
            black
            type="text"
          />
          <InputField
            required
            value={address}
            onChange={(e) => setAddess(e.target.value)}
            width="90%"
            placeholder="Street Address"
            black
            type="text"
          />
          <Button black showLoading={showLoading} text="Confirm" isSubmit />
        </form>
      </div>
    </div>
  );
};

export default ConfirmOrderPage;
